import React from 'react';

export default function LoadingAnime() {
  return (
    <div>
        <div className='loading'>MINJU | Full-Stack Developer</div>
        <h2>MINJU | Full-Stack Developer</h2>
    </div>
  );
}
